import ButtonLink from 'common/components/Elements/ButtonLink/ButtonLink';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import * as I from 'core/api/coreApiClient';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatCommandUrl } from 'core/utilities/command/command';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandExternalLink({ command, small }: ComponentProps) {
  const {
    id, title, active, shortcut, commandType, action, icon, label, styleHint,
  } = command;

  const ref = React.createRef<HTMLButtonElement>();

  const shortcutTrigger = useShortcut(...(shortcut || []));

  useEffect(() => {
    if (shortcutTrigger && ref && ref.current) {
      ref.current.click();
    }
  }, [shortcutTrigger, ref]);

  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);

  return (
    <ButtonLink
      action={action || 'tertiary'}
      url={formatCommandUrl(jsfUrl, command) || ''}
      openInNewTab={commandType !== I.CommandTypeConstants.JSFHREF}
      externalLink
      className={classes.command}
      title={title}
      small={small}
      disabled={active === false}
      e2eId={id}
      buttonRef={ref}
      buttonIcon={(icon && !label) || styleHint !== undefined}
    >
      <CommandLinkContent command={command} />
    </ButtonLink>
  );
}

export default CommandExternalLink;
